import classes from './RunTypeBadge.module.scss'

export interface Props {
  label: 'Replay' | 'Live run' | 'Exploratory' | 'Source space' | 'Destination space'
}

const RunTypeBadge = ({
  label
}: Props) =>
  <div className={classes.RunTypeBadge}>
    {label}
  </div>

export default RunTypeBadge
